import { AppConfig } from '../../../common/model/config';
import { ORDER_TYPE_CURBSIDE } from '../../../common/model/order-types';
import { eldoradoTheme } from '../themes/eldorado.theme';

export const eldoradoConfig: AppConfig = {
  appName: 'eldorado',
  appTitle: 'Shopping Eldorado',
  appDescription: 'Faça suas compras no Shopping Eldorado.',
  aggregator: 972,
  brand: 38,
  theme: eldoradoTheme,
  defaultOrderType: ORDER_TYPE_CURBSIDE,
  faviconPath: '/favicons/favicon-eldorado.ico',
  featureFlags: {
    embeddedApplication: true,
    getBrandThemeFromBackend: false,
    shuffleCompanyArray: false,
    gmapsAddress: false,
    showOptionsTabsAggregators: false,
    filterByDeliveryArea: false,
    useLocalAggregatorHeaderImg: false,
    removeLogoFromTheApp: true,
  },
};
